








































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import DynamicDocumentSignatureFieldTemplate from '../fields/dynamic-document-signature-field-template.vue';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import AmetrasResponsiveTabBar from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import DynamicDocumentSignatureEventctrlTemplate from '@/views/dynamicdocuments/fields/dynamic-document-signature-eventctrl-template.vue';

@Component({
  name: 'dynamic-document-signature-brick-template',
  components: {
    DynamicDocumentScreenWidthConfigurationTemplate,
    DynamicDocumentSignatureFieldTemplate,
    AmetrasResponsiveTabBar,
    DynamicDocumentSignatureEventctrlTemplate
  }
})
export default class DynamicDocumentSignatureBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig!: DisguiseDto.DynamicDocumentFieldDtoV2;
  @Prop({required: true}) context: DisguiseDto.DynamicDocumentContextDto | undefined;

  replacementToken: DisguiseDto.DynamicDocumentReplacementTokenDto[] = [];
  tabIndex: number = 0;
  innerValue: DisguiseDto.DynamicDocumentFieldDtoV2 | null = null;

  @Watch('value') valueChanged(newValue: DisguiseDto.DynamicDocumentFieldDtoV2) {
    this.innerValue = newValue;
  }

  @Watch('innerValue') innerValueChanged(newValue: DisguiseDto.DynamicDocumentFieldDtoV2) {
    this.$emit('input', newValue);
  }

  created() {
    this.innerValue = this.fieldConfig;
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DynamicDocumentReplacementTokenDto[]>(
        `/dynamicdocuments/v1/documents/contexttypes/${this.context}/replacementtoken/signature`
    ).then((response) => {
      this.replacementToken = response.data;
    });
  }

}
